module.exports = __webpack_public_path__ + "img/alumni-pande.4c3b1f4d.jpeg";